export default __webpack_public_path__ + "static/media/icon-up.30ef13cd.svg";